import {
    Directive,
    Input,
    ElementRef,
    Renderer2,
    OnInit,
    inject,
} from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
    selector: '[personaTooltip]',
    hostDirectives: [
        {
            directive: NgbTooltip,
            inputs: ['placement', 'triggers'],
        },
    ],
})
export class PersonaTooltipDirective implements OnInit {
    @Input() placement: string = 'top';
    @Input() triggers: string = 'hover';

    private elementRef = inject(ElementRef);
    private renderer = inject(Renderer2);
    private ngbTooltip = inject(NgbTooltip);

    private tooltipText =
        'A persona represents your role or job function (e.g., Software, Data, Cyber, and other IT related engineers). Different personas have access to role-specific tools and services tailored to their responsibilities.';

    ngOnInit() {
        // Set up the tooltip
        this.ngbTooltip.ngbTooltip = this.tooltipText;
        this.ngbTooltip.placement = this.placement;
        this.ngbTooltip.triggers = this.triggers;
        
        // Force tooltip to render in document body to avoid container clipping
        this.ngbTooltip.container = 'body';

        // Add the info icon after the element's content
        const iconSpan = this.renderer.createElement('span');
        this.renderer.addClass(iconSpan, 'persona-info-icon');
        this.renderer.setStyle(iconSpan, 'margin-left', '0.25rem');
        this.renderer.setStyle(iconSpan, 'cursor', 'pointer');
        this.renderer.setStyle(iconSpan, 'font-size', '14px');
        this.renderer.setStyle(iconSpan, 'vertical-align', 'top');

        const icon = this.renderer.createElement('i');
        this.renderer.addClass(icon, 'icon');
        this.renderer.addClass(icon, 'icon-information-circle');

        this.renderer.appendChild(iconSpan, icon);
        this.renderer.appendChild(this.elementRef.nativeElement, iconSpan);
    }
}
